export type IResourceFormatted = 'class' | 'group' | 'sprint';

export function formatResource(resource: string): IResourceFormatted | undefined {
  if (resource === 'grupo') return 'group';
  if (resource === 'turma') return 'class';
  if (resource === 'sprint') return 'sprint';
  return undefined;
}
